import { Banner, Layout } from "@shopify/polaris";

const CustomerOnHold = props => {
    return props.customer?.is_on_hold ? (
        <Layout.Section>
            <Banner
                title="This account is on hold."
                tone="critical"
            />
        </Layout.Section>
    ) : null;
}

export default CustomerOnHold;
